import { gql } from '@apollo/client';

export const SUGGEST_TAGS = gql`
  query SuggestTags($recipe: String!) {
    suggestTags(recipe: $recipe) {
      tagList
    }
  }
`;
